/*
 * Dollarlabs B2B — product-card pricing where the app embed stands down. TEMPORARY.
 *
 * The Collection Pricing embed gates its card rewriter by page type. The build
 * currently deployed (dollarlabs-b2b-86) only rewrites cards on these page types:
 *
 *   collection, searchresults/search, vendor, type/product-type, list-collections
 *
 * Everything else is skipped, so a tagged B2B buyer sees retail prices on:
 *   - the home page ("Explore Our Products" and any other card row)
 *   - product pages ("People Also Purchased", recently viewed, complementary)
 *   - custom pages that render product cards
 *
 * This prices those cards using the embed's own public SDK — no app internals and
 * no pricing maths here. It only touches a card that carries a real B2B discount,
 * which is what the embed's own rewriter does, so cards on a native Shopify sale
 * keep the theme's sale markup.
 *
 * It retires itself: on any page where the embed has already priced a card, it
 * stands down completely, so a fixed app release simply takes over. Delete this
 * file and its <script> tag in layout/theme.liquid once that release is live.
 *
 * Background: pages.dollarlabs.io/b2b/b2b-quickview-block-init
 */
(function () {
  'use strict';

  if (window.__dlCardPricingShim) return;
  window.__dlCardPricingShim = true;

  var SDK_POLL_MS = 250;
  var SDK_GIVE_UP_MS = 15000;
  // Long enough for the embed to finish its own pass (one Storefront round trip)
  // before we decide it has stood down on this page.
  var SETTLE_MS = 700;
  var DEBOUNCE_MS = 200;

  var RENDERED = '[data-dollarlabs-rendered="true"]';
  // Dollarlabs-owned regions and cart line prices, mirroring the embed's skip list.
  var OWNED =
    '[data-v3], [data-custom-price-js], [data-custom-price],' +
    '.dollarlabs_pricelist--product_price, .dollarlabs_order-form-mount,' + RENDERED;
  var CART = 'cart-drawer, cart-items, [class*="cart-item" i], form[action$="/cart"]';

  // Page types the DEPLOYED embed already handles. Asked in the same order it asks.
  var EMBED_ST = ['collection', 'searchresults', 'vendor', 'type', 'list-collections'];
  var EMBED_ANALYTICS = ['collection', 'search', 'vendor', 'product-type', 'list-collections'];
  var EMBED_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(collections|search|products\/vendors|products\/types)(\/|$)/i;

  function embedHandlesThisPage() {
    var st = window.__st && window.__st.p;
    if (st) return EMBED_ST.indexOf(st) !== -1;
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var analytics = meta && meta.page && meta.page.pageType;
    if (analytics) return EMBED_ANALYTICS.indexOf(analytics) !== -1;
    return EMBED_PATH.test(window.location.pathname);
  }

  function sdkReady() {
    return typeof window.DollarlabsGetBestPrice === 'function' &&
      window.DollarlabsPricing &&
      typeof window.DollarlabsPricing.renderOne === 'function';
  }

  function priceElFor(card) {
    var el = card.querySelector('.price');
    if (!el || el.closest(OWNED) || el.closest(CART)) return null;
    if (el.querySelector('.dollarlabs_pricelist--final_price, .dollarlabs_pricelist--regular_price')) return null;
    return el;
  }

  // A card is anything with its own add-to-cart form, which is also where the
  // variant id lives. Anything inside a <product-info> is either the page's own
  // product or a quick-view modal — neither is ours to touch. Themes render more
  // than one form per card (hover, mobile), so dedupe on the price node.
  function candidates() {
    var found = [];
    var seen = [];
    document.querySelectorAll('product-form input[name="id"]').forEach(function (input) {
      if (!input.value || input.closest('product-info')) return;
      var card = input.closest('.card-wrapper, .grid__item, li');
      if (!card) return;
      var priceEl = priceElFor(card);
      if (!priceEl || seen.indexOf(priceEl) !== -1) return;
      seen.push(priceEl);
      found.push({ priceEl: priceEl, variantId: input.value });
    });
    return found;
  }

  function price(item) {
    var el = item.priceEl;
    if (el.dataset.dlCardPricing) return;
    el.dataset.dlCardPricing = '1';

    window.DollarlabsGetBestPrice(item.variantId).then(function (result) {
      // No B2B discount: leave the theme's own price alone, native sale included.
      if (!result || !result.hasDiscount) return;
      el.dataset.variantId = String(item.variantId);
      el.dataset.originalPrice = String(result.originalPrice);
      el.dataset.showOriginalPrice = 'true';
      window.DollarlabsPricing.renderOne(el);
    }).catch(function () {
      delete el.dataset.dlCardPricing;   // transient failure: allow a later pass
    });
  }

  function scan() {
    candidates().forEach(price);
  }

  function start() {
    scan();
    var timer;
    var schedule = function () {
      clearTimeout(timer);
      timer = setTimeout(scan, DEBOUNCE_MS);
    };
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  }

  function begin() {
    if (embedHandlesThisPage()) return;
    // If the embed priced anything here, it has been fixed and owns this page now.
    window.setTimeout(function () {
      if (document.querySelector(RENDERED)) return;
      start();
    }, SETTLE_MS);
  }

  function waitForSdk() {
    var waited = 0;
    var tick = function () {
      if (sdkReady()) return begin();
      waited += SDK_POLL_MS;
      if (waited < SDK_GIVE_UP_MS) window.setTimeout(tick, SDK_POLL_MS);
    };
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSdk);
  } else {
    waitForSdk();
  }
})();
